import React, { useEffect, useCallback, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import styled from 'styled-components';

import axios from '../../axios';
import Results from '../search/results';
import Result from '../search/result';

//#region Styled Components
const PageContainer = styled.div`
  height: 100vh;
  width: 100vw;
  margin: 0 auto;
  padding: 2rem;
`;

const HomeLink = styled(Link)`
  color: var(--button-main);
  font-size: 1rem;
  cursor: pointer;
`;

const ListName = styled.h1`
  font-size: 2rem;
`;
//#endregion

const ViewList = () => {
  const [listResults, setListResults] = useState([]);
  const [listName, setListName] = useState('');
  const { listId } = useParams();

  const getList = useCallback(async () => {
    try {
      const response = await axios.get(`/lists/${listId}.json`);
      const results = [];
      for (let key in response.data.results) {
        results.push({
          ...response.data.results[key],
          id: key,
        });
      }
      setListResults(results);
      setListName(response.data.name);
    } catch (error) {
      throw error;
    }
  }, [listId]);

  useEffect(() => {
    getList();
  }, [getList]);

  const removeResult = async id => {
    try {
      await axios.delete(`/lists/${listId}/results/${id}.json`);
      const newResults = listResults.filter(result => {
        return result.id !== id;
      });
      setListResults(newResults);
    } catch (error) {
      throw error;
    }
  };

  return (
    <PageContainer>
      <HomeLink to="/">&lt; Back to Search</HomeLink>
      <ListName>{listName}</ListName>
      <div>
        {listResults.length > 0 && (
          <Results>
            {listResults.map((result, index) => {
              return (
                <Result
                  title={result.title}
                  price={result.price}
                  postUrl={result.postUrl}
                  imgUrl={result.imgUrl}
                  key={result.id}
                  id={result.id}
                  tab={index + 4}
                  selectedListId={listId}
                  mode="remove"
                  removeResult={removeResult}
                />
              );
            })}
          </Results>
        )}
      </div>
    </PageContainer>
  );
};

export default ViewList;
